module.exports = __webpack_public_path__ + "img/undraw_Data_re_80ws.57d7680c.svg";